// extracted by mini-css-extract-plugin
module.exports = {"checkbox__body":"styles_checkbox__body__25k-8","checkbox__text":"styles_checkbox__text__3r2Ed"};